import React from 'react'
import UploadVehicle from './upload-vehicle-page/UploadVehicle'

const UploadVehiclePage = () => {
  return (
    <div>
        <UploadVehicle />
    </div>
  )
}

export default UploadVehiclePage